// extracted by mini-css-extract-plugin
module.exports = {"name":"HeadOfHouse_name__3ZRnr","contacts":"HeadOfHouse_contacts__1Aawr","email":"HeadOfHouse_email__2iajL","tel":"HeadOfHouse_tel__1ADfI"};